// extracted by mini-css-extract-plugin
export default {"wrapper":"MainTitle_wrapper__FYWQR","title":"MainTitle_title__QRf5N"};